import React from 'react';
import * as Yup from 'yup';
import { Grid } from '@mui/material';
import {
  SparkForm,
  SparkFormButton,
  SparkPasswordField,
} from 'sharedComponents/SparkForm';
import { useConfirmPassword } from 'hooks/auth';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';

type ResetPasswordFormFormValues = {
  newPassword: string;
  confirmPassword: string;
};

const initialValues = {
  newPassword: '',
  confirmPassword: '',
};
const validationSchema = Yup.object({
  newPassword: Yup.string().required('Password is Required'),
  confirmPassword: Yup.string()
    .required('Confirm Password is Required')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
});

function ResetPasswordForm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const { mutateAsync: resetPassword } = useConfirmPassword();
  const handleLogin = async (loginCredentials: ResetPasswordFormFormValues) => {
    if (!email || !token) {
      return;
    }
    await resetPassword({
      email,
      password: loginCredentials.newPassword,
      confirmPassword: loginCredentials.confirmPassword,
    });
    navigate(SPARK_ROUTES.LOGIN);
  };

  return (
    <SparkForm
      initialValues={initialValues}
      onSave={handleLogin}
      validationSchema={validationSchema}
    >
      <SparkPasswordField
        name='newPassword'
        label='New Password'
        size={12}
        placeholder='Enter New Password'
        renderForgetPasswordLink={false}
      />
      <SparkPasswordField
        name='confirmPassword'
        label='Confirm Password'
        size={12}
        placeholder='Confirm Password'
        renderForgetPasswordLink={false}
      />

      <Grid item container justifyContent='center'>
        <SparkFormButton
          sx={{
            padding: 2,
            textDecoration: 'none',
            fontSize: '14px',
          }}
        >
          RESET PASSWORD
        </SparkFormButton>
      </Grid>
    </SparkForm>
  );
}

export default ResetPasswordForm;
